import styled from 'styled-components'

const getWatermarkHeight = (size: string, width: number, height: number) => {
	if(width < height || width === height) {
		switch (size) {
			case 'medium':
				return '50%';
			case 'large':
				return '70%';
			default:
				return '30%'
		}
	} else {
		return 'auto';
	}
}

const getWatermarkWidth = (size: string, width: number, height: number) => {
	if(width > height) {
		switch (size) {
			case 'medium':
				return '60%';
			case 'large':
				return '80%';
			default:
				return '40%'
		}
	} else {
		return 'auto';
	}
}

const getWatermarkPosition = (position: string) => {
	switch (position) {
		case '0': return `top: 0; left: 0;`;
		case '1': return `top: 0; left: 50%; transform: translateX(-50%);`;
		case '2': return `top: 0; right: 0;`;
		case '3': return `top: 50%; left: 0; transform: translateY(-50%);`;
		case '4': return `top: 50%; left: 50%; transform: translate(-50%, -50%);`;
		case '5': return `top: 50%; right: 0; transform: translateY(-50%);`;
		case '6': return `bottom: 0; left: 0;`;
		case '7': return `bottom: 0; left: 50%; transform: translateX(-50%);`;
		case '8': return `bottom: 0; right: 0;`;
		default: return `bottom: 0; right: 0;`;
	}
};

const getMarginRotate = (imageRotation: number, photoWidth: number, photoHeight: number) => {
	if (imageRotation % 180 !== 0) {
		if (photoHeight > photoWidth) {
			return `margin-top: ${-((400 - photoHeight) / 2)}px; margin-left: ${(400 - photoHeight) / 2}px;`;
		} else if (photoWidth > photoHeight) {
			return `margin: -${(400 - photoHeight) / 2}px auto;`;
		}
	}
	return "margin: auto;";
};

const getHeightRotate = ($imageRotation: number, $photoHeight: number) => {
	return $imageRotation % 180 !== 0 ? `${$photoHeight}px` : 'auto';
};

interface StyledPhotoEditorContainerProps {
	$isModal: boolean;
}
export const StyledPhotoEditorContainer = styled.div<StyledPhotoEditorContainerProps>`
	margin: ${({ $isModal }) => $isModal ? 0 : '20px'};
	${({ $isModal }) => $isModal && 'width: 100%'};
`;

export const StyledPhotoEditorFramed = styled.div`
  width: 100%;
  border-radius: 0;
`;

export const StyledPhotoEditorFramedContent = styled.div`
  background-color: black;
  position: relative;
	padding-bottom: 30px;
`;

export const StyledPhotoEditorFramedSpinnerContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  color: white;
  background-color: black;
  padding: 5rem 3.75rem;
  border-radius: 0;
	height: 350px;
	justify-content: center;
`;

export const StyledPhotoEditorLoadingSpinner = styled.div`
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-top: 4px solid white;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const StyledPhotoEditorControlsContainer = styled.div`
  height: 88px;
	display: flex;
	justify-content: space-between;
  padding: 1.25rem;
`;

interface StyledPhotoEditorButtonProps {
	$position: string;
}
export const StyledPhotoEditorButton = styled.button<StyledPhotoEditorButtonProps>`
	display: flex;
  align-items: center;
  height: 48px;
  font-size: 16px;
  font-weight: 600;
  color: ${({ $position }) => ($position === 'right' ? '#3aac6b' : '#eee')};
  background-color: black;
  border: 2px solid ${({ $position }) => ($position === 'right' ? '#3aac6b' : '#eee')};
  border-radius: 100%;
  padding: ${({ $position }) => ($position === 'center' ? '6px' : '10px')};
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  outline: none;
	width: 48px;

  &:hover {
    border-color: #3aac6b !important;
    ${({ $position }) => $position === 'right' && 'background-color: #3aac6b'};

    svg {
      color: ${({ $position }) => ($position === 'right' ? 'white' : '#3aac6b')};

      path {
        fill: #3aac6b;
      }
    }
  }

  &:focus {
    border-color: #eee;
  }

  svg,
  img {
    width: ${({ $position }) => ($position === 'center' ? '32px' : '24px')};
    height: ${({ $position }) => ($position === 'center' ? '32px' : '24px')};
    transition: all 0.2s ease-in-out;
  }

  svg path {
    transition: all 0.2s ease-in-out;
  }
`;

export const StyledPhotoEditorPhotoStickersContainer = styled.div`
  padding: 0 10px 10px 10px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  background-color: black;
  overflow: auto;
  z-index: 1;

  &::-webkit-scrollbar {
    background-color: rgba(0, 0, 0, 0.6);
    width: 16px;

    &-track {
      background-color: rgba(0, 0, 0, 0.6);

      &:hover {
        background-color: rgba(0, 0, 0, 0.8);
      }
    }

    &-thumb {
      background-color: #c1c1c1;
      border-radius: 16px;
      border: 4px solid black;

      &:hover {
        background-color: #7d7d7d;
      }
    }

    &-button {
      display: none;
    }
  }
`;

export const StyledPhotoEditorEmojiButtons = styled.button`
  background: transparent;
  border: none;

  &:not(:last-of-type) {
    margin-right: 15px;
  }

  img, svg {
    width: 80px;
    height: 80px;
  }
`;

interface StyledPhotoEditorPhotoUploadContainerProps {
	$imageRotation: number;
	$photoWidth: number;
	$photoHeight: number;
}
export const StyledPhotoEditorPhotoUploadContainer = styled.div<StyledPhotoEditorPhotoUploadContainerProps>`
  position: relative;
	box-sizing: border-box;
	width: 100%;
  height: ${({ $imageRotation, $photoHeight }) => getHeightRotate($imageRotation, $photoHeight)};
  margin: auto;
	overflow: hidden;
`;

interface StyledPhotoEditorPhotoUploadImgProps {
	$imageRotation: number;
	$photoHeight: number;
	$photoWidth: number;
}
export const StyledPhotoEditorPhotoUploadImg = styled.img<StyledPhotoEditorPhotoUploadImgProps>`
  ${({ $imageRotation, $photoWidth, $photoHeight }) => getMarginRotate($imageRotation, $photoWidth, $photoHeight)}
  transform: ${({ $imageRotation }) => `rotate(${$imageRotation}deg)`};
	transform-origin: center;
`;

interface StyledPhotoEditorWatermarkUploadImgProps {
	$size: string;
	$width: number;
	$height: number;
	$position: string;
	$opacity: string;
}
export const StyledPhotoEditorWatermarkUploadImg = styled.img<StyledPhotoEditorWatermarkUploadImgProps>`
  position: absolute;
  ${({ $position }) => getWatermarkPosition($position)}
  width: ${({ $size, $width, $height }) => getWatermarkWidth($size, $width, $height)};
  height: ${({ $size, $width, $height }) => getWatermarkHeight($size, $width, $height)};
  opacity: ${({ $opacity }) => `${$opacity}%`};
`;

export const StyledPhotoEditorPhotoCameraContainer = styled.div`
  position: relative; 
	box-sizing: border-box;
	width: 100%;
  height: auto;
  margin: auto;
	border: 1px solid red;
`;

interface StyledPhotoEditorPhotoCameraImgProps {
	$imageRotation: number;
}
export const StyledPhotoEditorPhotoCameraImg = styled.img<StyledPhotoEditorPhotoCameraImgProps>`
  width: 100%;
  height: auto;
  margin: auto;
  transform: ${({ $imageRotation }) => `rotate(${$imageRotation}deg)`};
`;

interface StyledPhotoEditorWatermarkImgProps {
	$size: string;
	$width: number;
	$height: number;
	$position: string;
	$opacity: string;
}
export const StyledPhotoEditorWatermarkImg = styled.img<StyledPhotoEditorWatermarkImgProps>`
  position: absolute;
  ${({ $position }) => getWatermarkPosition($position)}
 	width: ${({ $size, $width, $height }) => getWatermarkWidth($size, $width, $height)};
	height: ${({ $size, $width, $height }) => getWatermarkHeight($size, $width, $height)};
	opacity: ${({ $opacity }) => `${$opacity}%`};
`;

interface StyledPhotoEditorStickerContainerProps {
	$width: number;
	$height: number;
}
export const StyledPhotoEditorStickerContainer = styled.div<StyledPhotoEditorStickerContainerProps>`
	width: ${({ $width }) => $width}px;
	height: ${({ $height }) => $height}px;
  z-index: 1000;
  will-change: transform;
`;

export const StyledPhotoEditorStickerImg = styled.img`
  width: 100%;
  height: 100%;
  pointer-events: none;
`;

export const StyledPhotoEditorStickerDelete =  styled.div`
  position: absolute;
  bottom: -45px;
  left: 50%;
  transform: translateX(-50%);
  width: 20px;
  height: 20px;
  background: #fff;
  border: 2px solid #326cb9;
  border-radius: 100%;
  pointer-events: all;
  cursor: grab;
  display: flex;
  align-items: center;
  justify-content: center;
`;
